import React from "react"

type ArticleCardProps = {
  title: string
  dateText: string
  logo: string
  excerpt: string
  article: string
  articleOnSite?: string
  image: string
  imageAlt: string
  imageTitle: string
}

export const ArticleCard = ({
  title,
  dateText,
  excerpt,
  article,
  articleOnSite,
  image,
  imageAlt,
  imageTitle,
}: ArticleCardProps) => {
  return (
    <div className="grid grid-cols-12 gap-6">
      <div className="col-span-12 mb-6 lg:mb-8 lg:col-span-4 lg:col-start-9">
        <img
          loading="lazy"
          className="w-full"
          data-testid="articleItemImage"
          width="360"
          height="240"
          src={image}
          alt={imageAlt}
          title={imageTitle}
        ></img>
      </div>
      <div className="col-span-12 lg:row-start-1 lg:col-start-1 lg:col-span-7">
        <div className="flex items-center">
          <p className="mt-0 mb-3 overline">{dateText}</p>
        </div>
        <h3 className="mt-0 mb-5 font-serif text-2xl lg:text-2xl leading-snug">
          {title}
        </h3>
        <p className="mt-0 mb-5">{excerpt}</p>
        <div className="flex flex-wrap gap-2">
          {articleOnSite && (
            <a
              className="inline-block self-start px-5 py-3 bg-blackNew text-white font-mono text-xs tracking-wider uppercase no-underline"
              href={articleOnSite}
            >
              Read on-site &rarr;
            </a>
          )}
          {article && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block self-start px-5 py-3 border border-solid border-blackNew text-blackNew font-mono text-xs tracking-wider uppercase no-underline"
              href={article}
            >
              Read off-site &rarr;
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
